<h2 mat-dialog-title tabindex="0">Verfahrenszuordnungen</h2>
@if (verfahren.zuordnungen) {
	<h3>Hauptverfahren:
		<schir-int-client-aktenzeichen [aktenzeichen]="verfahren.zuordnungen.hauptverfahren.aktenzeichen" [verfahrenId]="verfahren.zuordnungen.hauptverfahren.verfahrenId" [preOpenAction]="closeDialog"/>
	</h3>
} @else {
	<h3>Neues Hauptverfahren wird:
		<schir-int-client-aktenzeichen [aktenzeichen]="verfahren.stammdaten.aktenzeichen"/>
	</h3>
}
<div class="lists">
	<div class="list">
		<h3>Untergeordnete Verfahren</h3>
		<ul aria-label="Untergeordnete Verfahren">
			@for (verfahren of verfahrenControl.value; track $index) {
				<li>
					<schir-int-client-aktenzeichen
							[aktenzeichen]="verfahren.aktenzeichen"
							[verfahrenId]="verfahren.verfahrenId"
							[preOpenAction]="closeDialog"
					/>
					<button mat-icon-button (click)="deleteItem($index)">
						<span class="cdk-visually-hidden">{{ verfahren.aktenzeichen }} entfernen</span>
						<mat-icon>delete</mat-icon>
					</button>
				</li>
			} @empty {
				<li class="empty-list-row">
					Kein Verfahren untergeordnet
				</li>
			}
		</ul>
	</div>
	<div class="list">
		<mat-form-field>
			<mat-label>Verfahren suchen</mat-label>
			<input matInput [(ngModel)]="searchAktenzeichen" (keyup.enter)="search()">
			<button matSuffix mat-icon-button (click)="search()">
				<span class="cdk-visually-hidden">Verfahren suchen</span>
				<mat-icon>search</mat-icon>
			</button>
		</mat-form-field>
		<ul aria-label="Gefundene Verfahren">
			@for (verfahren of filteredVerfahren; track $index) {
				<li>
					<schir-int-client-aktenzeichen [aktenzeichen]="verfahren.aktenzeichen"/>
					<button mat-icon-button (click)="assignItem($index)">
						<span class="cdk-visually-hidden">{{ verfahren.aktenzeichen }} hinzufügen</span>
						<mat-icon>add</mat-icon>
					</button>
				</li>
			}
			@if (hasMore) {
				<li>
					<button mat-stroked-button (click)="search(false)" type="button" class="focus-inwards-dark" matTooltip="Weitere Verfahren anzeigen">
						<span class="cdk-visually-hidden">Weitere Verfahren anzeigen</span>
						Mehr
					</button>
				</li>
			}
		</ul>
	</div>
</div>
<mat-dialog-actions>
	<button mat-stroked-button (click)="onCancel()" type="button" class="focus-inwards-dark">
		Abbrechen
	</button>
	<button mat-flat-button color="primary" type="button" (click)="onSave()">
		Speichern
	</button>
</mat-dialog-actions>
